import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { AccordionModule } from "ngx-accordion";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonHttpService } from "../commonHttp.service";
import { LoaderService } from "../../_shared/services/loader.service";
import { AddToCartService } from "../../_shared/services/add-to-cart.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { } from "jquery";
import { HttpClient } from "@angular/common/http";
import { ThrowStmt } from "@angular/compiler";
import jsSHA from "jssha";
import { ElementRef } from '@angular/core';
declare var $;

@Component({
  selector: "app-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.css"],
})
export class CheckoutComponent implements OnInit {
  @ViewChild("content") modalContent: TemplateRef<any>;
  closeResult: any;
  baseUrl: any = environment.apiUrl;
  customerId: any;
  Address: any = {};
  add: any = {};
  Addresses: any = [];
  PaymentMode: any = [];
  Slot: any = [];
  referralPoints: number = 0;
  nowPoints: number = 0;
  orderDetails: any = {};
  availableNowPoints: number = 0;
  availableReferralPoints: number = 0;
  customerRefferalPoints: number = 0;
  paymentURL = environment.paymentURL;
  cartProducts: any = [];
  merchantId: any;
  NextSlot: any = [
    {
      etimeSlotId: 1,
      etimeSlotName: "Morning",
      etimeSlotStart: "10:00:00",
      etimeSlotEnd: "13:00:00",
      etimeSlotUpto: "09:00:00",
      isActive: true,
      isDeleted: false,
      createdDate: "2017-12-28T04:53:44.963",
      updatedDate: null,
      eSlotDate: "",
    },
    {
      etimeSlotId: 2,
      etimeSlotName: "AfterNoon",
      etimeSlotStart: "14:00:00",
      etimeSlotEnd: "17:00:00",
      etimeSlotUpto: "13:00:00",
      isActive: true,
      isDeleted: false,
      createdDate: "2017-12-28T07:03:45.097",
      updatedDate: "2017-12-28T11:38:06.293",
      eSlotDate: "",
    },
    {
      etimeSlotId: 6,
      etimeSlotName: "Evening",
      etimeSlotStart: "18:00:00",
      etimeSlotEnd: "21:00:00",
      etimeSlotUpto: "17:00:00",
      isActive: true,
      isDeleted: false,
      createdDate: "2017-12-29T10:12:17.307",
      updatedDate: null,
      eSlotDate: "",
    },
  ];
  LastSlot: any = [
    {
      etimeSlotId: 1,
      etimeSlotName: "Morning",
      etimeSlotStart: "10:00:00",
      etimeSlotEnd: "13:00:00",
      etimeSlotUpto: "09:00:00",
      isActive: true,
      isDeleted: false,
      createdDate: "2017-12-28T04:53:44.963",
      updatedDate: null,
      eSlotDate: "",
    },

    {
      etimeSlotId: 2,
      etimeSlotName: "AfterNoon",
      etimeSlotStart: "14:00:00",
      etimeSlotEnd: "17:00:00",
      etimeSlotUpto: "13:00:00",
      isActive: true,
      isDeleted: false,
      createdDate: "2017-12-28T07:03:45.097",
      updatedDate: "2017-12-28T11:38:06.293",
      eSlotDate: "",
    },

    {
      etimeSlotId: 6,
      etimeSlotName: "Evening",
      etimeSlotStart: "18:00:00",
      etimeSlotEnd: "21:00:00",
      etimeSlotUpto: "17:00:00",
      isActive: true,
      isDeleted: false,
      createdDate: "2017-12-29T10:12:17.307",
      updatedDate: null,
      eSlotDate: "",
    },
  ];
  PaymentMod: any = [];

  PaymentModx: any = [];
  PaymentModxe: any = [];
  Slotdate;
  etimeDateDisplayed;
  dateReturnedFromFulldate;
  FirstSuccessiveDate;
  SecondSuccessiveDate;
  etimeDisplayed;
  timeString;
  slotTime;
  slotId: number;
  AddressId: number = 0;
  orderDueDate;
  paymentModeId;
  todaysDate;
  shippingCharge = 0;
  paymentStatusId: number;
  couponDetails: any;
  TotalCessAmount: any = 0;
  baseAmount: number;
  tabsDisabled: boolean = true;
  PayAmount = 0.0;
  CustomerDetails = { refferalPoints: 0, nowPoints: 0 };
  referralDiscount: any = 0;
  disableOrder: boolean;
  cartItems: any = [];
  cart: any = {};
  EcartGrandTotal: number = 0;
  EcartTotal: number = 0;
  EcartTotalDiscount: number = 0;
  netPayable: number = 0;
  isAddressSaved: boolean = true;
  couponError: boolean = false;
  couponAmount: number = 0;
  couponCode: any;
  orderedProduct: any = [];
  orderId: number = 0;
  couponId: any = null;
  modeAvailabe: boolean = true;
  city: any;
  pageDown: boolean = true;
  showSlotErrorMsg: boolean = false;
  down: boolean = true;
  message: string = "";
  showLoader: boolean;
  customerName: any;
  ppavl: boolean = false;
  eOrderArray = [];
  // responseForPayment={}
  responsePayment: any;
  mobileNumber: any;
  imageUrl: any = environment.imageUrl;
  //isFromChekoutPhonePe ;
  constructor(
    private myElement: ElementRef,
    private service: CommonHttpService,
    private http: HttpClient,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private modalService: NgbModal
  ) {


  }

  ngOnInit() {
    this.mobileNumber = localStorage.getItem("customerMobile")
    console.log(this.mobileNumber)
    let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
    this.customerId = Number(localStorage.getItem("customerId"));
    // let customerName = JSON.parse(localStorage.getItem("customerName"));
    this.customerName = localStorage.getItem("customerName").split(" ")[0];
    console.log(this.customerName);
    console.log(this.customerId);
    console.log(IsPhonepe);
    this.add.name = this.customerName;
    this.add.alternateMobileNumber = this.mobileNumber;
    if (IsPhonepe == "phonepe") {
      this.ppavl = true;
      console.log(this.ppavl);
    }
    // this.phonepePayment();
    //  this.route.queryParams
    //    .filter((params) => params.utm_source)
    //    .subscribe((params) => {
    //      console.log(params); // {order: "popular"}
    //      if (params.utm_source != null) {
    //        this.ppavl = true;
    //      }
    //  });
    window.scrollTo(0, 0);
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    this.customerId = localStorage.getItem("customerId");
    this.disableOrder = false;
    this.isAddressSaved = false;
    this.cart;

    // for (var i = 0; i < this.cartItems.length; i++) {
    //   // console.log(this.cartItems.categoryId)
    //   if (this.cartItems[i].CategoryId != '331') {
    //     // await console.log(this.cartItems.CategoryId)
    //     var isGroceryProductsPresent = true
    //   }
    // }
    // for (var i = 0; i < this.cartItems.length; i++) {
    //   // console.log(this.cartItems.categoryId)
    //   if (this.cartItems[i].CategoryId == '331' && isGroceryProductsPresent == true) {
    //     // await console.log(this.cartItems.CategoryId)
    //     window.location.href = ""
    //   }
    // }
    this.city = "Bhubaneswar";
    this.getDeliverySlots();
    this.getCustomerData();
    this.getAddress();
    this.getPaymentModes();
    this.calculateTotals();
    this.siteDown();
  }

  siteDown = function () {
    this.service
      .get(this.baseUrl + "ErrorStatusAPI/GetCheckoutPageErrorStatus/")
      .subscribe(
        (data) => {
          console.log(data);
          var statusForDown = data;
          console.log(statusForDown.length);
          for (let i = 0; i < statusForDown.length; i++) {
            if (statusForDown[i].id == 4) {
              this.down = statusForDown[i].status;
              this.message = statusForDown[i].message;
            }
          }
        },
        (error) => { }
      );
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  };
  calculateTotals() {
    this.EcartTotal = 0;
    this.EcartGrandTotal = 0;
    this.EcartTotalDiscount = 0;
    for (var i = 0; i < this.cartItems.length; i++) {
      this.orderedProduct.push({
        BatchId: this.cartItems[i].BatchId,
        Discount:
          (this.cartItems[i].Mrp - this.cartItems[i].Price) *
          this.cartItems[i].Quantity,
        ProductId: this.cartItems[i].ProductId,
        Quantity: this.cartItems[i].Quantity,
        Rate: this.cartItems[i].Price,
        StoreId: null,
        SubTotal: this.cartItems[i].SubTotal,
        TaxAmount: 0,
        TaxCess: 0,
      });
      this.EcartTotal =
        this.EcartTotal + this.cartItems[i].Mrp * this.cartItems[i].Quantity;
      this.EcartGrandTotal =
        this.EcartGrandTotal +
        this.cartItems[i].Price * this.cartItems[i].Quantity;
      this.EcartTotalDiscount =
        this.EcartTotalDiscount +
        (this.cartItems[i].Mrp - this.cartItems[i].Price) *
        this.cartItems[i].Quantity;
    }
    if (this.EcartGrandTotal < 500) {
      this.shippingCharge = 50;
    } else {
      this.shippingCharge = 0;
    }
    this.EcartTotal = Math.round(this.EcartTotal);
    this.EcartGrandTotal = Math.round(this.EcartGrandTotal);
    this.netPayable = Math.round(this.EcartGrandTotal + this.shippingCharge);
  }

  getDeliverySlots() {
    this.service.get(this.baseUrl + "EOrderAPI/GetAllSlotDetails").subscribe(
      (data) => {
        console.log(data);
        var todaySlot1 = data.todaySlot1;
        var todaySlot2 = data.todaySlot2;
        var todaySlot3 = data.todaySlot3;
        var tomorrowSlot1 = data.tomorrowSlot1;
        var tomorrowSlot2 = data.tomorrowSlot2;
        var tomorrowSlot3 = data.tomorrowSlot3;
        var dayAfterTomorrowSlot1 = data.dayAfterTomorrowSlot1;
        var dayAfterTomorrowSlot2 = data.dayAfterTomorrowSlot2;
        var dayAfterTomorrowSlot3 = data.dayAfterTomorrowSlot3;
        console.log(todaySlot1);
        // delivery slot data
        this.service
          .get(this.baseUrl + "SlotDownAPI/GetByToDayDate/")
          .subscribe(
            (data) => {
              console.log(data);
              var todaySlotDown1 = data.todaySlot1;
              var todaySlotDown2 = data.todaySlot2;
              var todaySlotDown3 = data.todaySlot3;
              var tomorrowSlotDown1 = data.tomorrowSlot1;
              var tomorrowSlotDown2 = data.tomorrowSlot2;
              var tomorrowSlotDown3 = data.tomorrowSlot3;
              var dayAfterTomorrowSlotDown1 = data.dayAfterTomorrowSlot1;
              var dayAfterTomorrowSlotDown2 = data.dayAfterTomorrowSlot2;
              var dayAfterTomorrowSlotDown3 = data.dayAfterTomorrowSlot3;

              this.service
                .create(this.baseUrl + "DeliverySlotAPI/GetAll", "Option")
                .subscribe(
                  (data) => {
                    this.Slot = data;
                    console.log("slot");
                    console.log(this.Slot);
                    for (var i = 0; i < this.Slot.length; i++) {
                      this.Slotdate = this.Slot[i].etimeSlotDate;
                      this.slotTime = this.Slot[i].etimeSlotUpto;
                      console.log(this.slotTime);

                      var today = new Date();
                      this.todaysDate =
                        today.getFullYear() +
                        "-" +
                        (today.getMonth() + 1) +
                        "-" +
                        today.getDate();
                      this.timeString = [
                        today.getHours() +
                        ":" +
                        today.getMinutes() +
                        ":" +
                        today.getSeconds(),
                      ];

                      if (this.Slot[i].etimeSlotId == 1) {
                        this.Slot[i].slotLimit = todaySlot1;
                        this.Slot[i].slotLimitDown = todaySlotDown1;
                      } else if (this.Slot[i].etimeSlotId == 2) {
                        this.Slot[i].slotLimit = todaySlot2;
                        this.Slot[i].slotLimitDown = todaySlotDown2;
                      } else if (this.Slot[i].etimeSlotId == 6) {
                        this.Slot[i].slotLimit = todaySlot3;
                        this.Slot[i].slotLimitDown = todaySlotDown3;
                      }

                      console.log(this.Slot[i].etimeSlotUpto < this.timeString);

                      if (
                        this.Slot[i].etimeSlotUpto < this.timeString ||
                        this.Slot[i].slotLimit >= 10 ||
                        this.Slot[i].slotLimitDown != 0
                      ) {
                        this.Slot[i].isDisabled = true;
                      } else {
                        this.Slot[i].isDisabled = false;
                      }

                      // if (this.slotTime < this.timeString) {
                      //   this.Slot[i].isDisabled = true
                      // }
                      // else if (this.slotTime > this.timeString) {
                      //   this.Slot[i].isDisabled = false
                      // }
                      this.etimeDateDisplayed = this.convert(this.Slotdate);
                      this.FirstSuccessiveDate = this.nextDate(this.Slotdate);
                      this.SecondSuccessiveDate = this.nextConsequtiveDate(
                        this.Slotdate
                      );
                    }
                    for (var i = 0; i < this.NextSlot.length; i++) {
                      this.NextSlot[i].eSlotDate = this.FirstSuccessiveDate;
                      this.etimeDisplayed = this.convert(
                        this.NextSlot[i].eSlotDate
                      );

                      if (this.NextSlot[i].etimeSlotId == 1) {
                        this.NextSlot[i].slotLimit = tomorrowSlot1;
                        this.NextSlot[i].slotLimitDown = tomorrowSlotDown1;
                      } else if (this.NextSlot[i].etimeSlotId == 2) {
                        this.NextSlot[i].slotLimit = tomorrowSlot2;
                        this.NextSlot[i].slotLimitDown = tomorrowSlotDown2;
                      } else if (this.NextSlot[i].etimeSlotId == 6) {
                        this.NextSlot[i].slotLimit = tomorrowSlot3;
                        this.NextSlot[i].slotLimitDown = tomorrowSlotDown3;
                      }

                      if (
                        this.NextSlot[i].slotLimit >= 10 ||
                        this.NextSlot[i].slotLimitDown != 0
                      ) {
                        this.NextSlot[i].isDisabled = true;
                      } else {
                        this.NextSlot[i].isDisabled = false;
                      }
                    }
                    this.Slot.nxtSlot = this.NextSlot;
                    for (var i = 0; i < this.LastSlot.length; i++) {
                      this.LastSlot[i].eSlotDate = this.SecondSuccessiveDate;
                      this.etimeDisplayed = this.convert(
                        this.LastSlot[i].eSlotDate
                      );
                      if (this.LastSlot[i].etimeSlotId == 1) {
                        this.LastSlot[i].slotLimit = dayAfterTomorrowSlot1;
                        this.LastSlot[
                          i
                        ].slotLimitDown = dayAfterTomorrowSlotDown1;
                      } else if (this.LastSlot[i].etimeSlotId == 2) {
                        this.LastSlot[i].slotLimit = dayAfterTomorrowSlot2;
                        this.LastSlot[
                          i
                        ].slotLimitDown = dayAfterTomorrowSlotDown2;
                      } else if (this.LastSlot[i].etimeSlotId == 6) {
                        this.LastSlot[i].slotLimit = dayAfterTomorrowSlot3;
                        this.LastSlot[
                          i
                        ].slotLimitDown = dayAfterTomorrowSlotDown3;
                      }

                      if (
                        this.LastSlot[i].slotLimit >= 10 ||
                        this.LastSlot[i].slotLimitDown != 0
                      ) {
                        this.LastSlot[i].isDisabled = true;
                      } else {
                        this.LastSlot[i].isDisabled = false;
                      }
                    }

                    this.Slot.lastSlot = this.LastSlot;
                  },
                  (error) => { }
                );
            },
            (error) => { }
          );
      },
      (error) => { }
    );
  }

  getCustomerData = function () {
    this.service
      .get(this.baseUrl + "CustomerAPI/GetDetails/" + this.customerId)
      .subscribe(
        (data) => {
          console.log(data);
          this.CustomerDetails = data;
          this.availableNowPoints = this.CustomerDetails.nowPoints;
          this.customerRefferalPoints = this.CustomerDetails.refferalPoints;
          this.availableReferralPoints =
            this.customerRefferalPoints <
              Math.round(this.EcartGrandTotal * 0.05)
              ? this.customerRefferalPoints
              : Math.round(this.EcartGrandTotal * 0.05);
          if (this.CustomerDetails.mobileNumber == null) {
            this.openWarningModel();
          }
        },
        (error) => { }
      );
  };

  getAddress() {
    this.service
      .create(
        this.baseUrl + "CustomerAddressAPI/Get/" + this.customerId,
        "Option"
      )
      .subscribe(
        (data) => {
          this.Addresses = data;
          console.log(this.Addresses);
        },
        (error) => { }
      );
  }

  convert = function (str) {
    var date = new Date(str);
    var time = date.getHours();
    return (
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    );
  };

  getPaymentModes() {
    this.service
      .create(this.baseUrl + "EPaymentAPI/GetAll", "Option")
      .subscribe(
        (data) => {
          console.log(data);
          this.PaymentMode = data.sort((n1, n2) => n1 - n2);
          this.PaymentModx = this.PaymentMode.slice(5);
          this.PaymentMod = this.PaymentMode.slice(0, 5);
          console.log(this.PaymentMode);
          console.log(this.PaymentModx);
          console.log(this.PaymentMod);
          if (this.ppavl == true) {
            this.PaymentMod = this.PaymentModx;
          } else {
            this.PaymentMod = this.PaymentMod;
          }
          console.log(this.PaymentMod);
        },
        (error) => { }
      );
  }

  onAddressSubmit = function (Address) {
    console.log(this.add);
    const AddressDetails = {
      CustomerId: this.customerId,
      CustomerAddress: [
        {
          CustomerId: Number(this.customerId),
          Name: Address.name,
          AlternateMobileNumber: Address.alternateMobileNumber,
          Pincode: Number(Address.pincode),
          Locality: Address.locality,
          Address: Address.address,
          City: "Bhubaneswar",
          State: "Odisha",
          Landmark: Address.landmark,
        },
      ],
    };

    this.service
      .create(this.baseUrl + "CustomerAddressAPI/Post", AddressDetails)
      .subscribe(
        (data) => {
          console.log(data);
          this.isAddressSaved = true;
          this.getAddress();
          this.selectAdreesListTab();
        },
        (error) => { }
      );
  };

  selectAdreesListTab() {
    $("ul.nav-tabs li:first").addClass("active");
    $("ul.nav-tabs li:first a").addClass("active");
    $("ul.nav-tabs li:last").removeClass("active");
    $("ul.nav-tabs li:last a").removeClass("active");
    $(".tab-content div:first").addClass("active");
    $("#add-address").removeClass("active");
  }

  nextDate(str) {
    var d = new Date(str);
    d.setDate(d.getDate() + 1);
    return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
  }

  nextConsequtiveDate(str) {
    var d = new Date(str);
    d.setDate(d.getDate() + 2);
    return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
  }

  selectedAddress = function (addressId) {
    this.AddressId = addressId;
    console.log(this.Address);
    this.myElement.nativeElement.ownerDocument.getElementById('timeslot').scrollIntoView({ behavior: 'smooth' });

  };
  selectedSlot = function (slotId, date) {
    this.showSlotErrorMsg = false;
    this.slotId = slotId;
    this.orderDueDate = date;
    if (this.ppavl == true) {
      this.paymentModeId = 6;
      this.paymentStatusId = 2;
    }
    if (this.ppavl == false) {
      this.myElement.nativeElement.ownerDocument.getElementById('paymentmode').scrollIntoView({ behavior: 'smooth' });
    }
    else if (this.ppavl == true) {
      this.myElement.nativeElement.ownerDocument.getElementById('PlaceOrderBlock').scrollIntoView({ behavior: 'smooth' });

    }

  };

  selectedPaymentMode = function (paymentModeId) {
    this.paymentModeId = paymentModeId;
    this.paymentStatusId = 2;
    if (window.screen.width < 768) {
      this.myElement.nativeElement.ownerDocument.getElementById('PlaceOrderBlock').scrollIntoView({ behavior: 'smooth' });

    }
    else {
      this.myElement.nativeElement.ownerDocument.getElementById('PlaceOrderBlock').scrollIntoView({ behavior: 'smooth' });

    }
    //  this.myElement.nativeElement.ownerDocument.getElementById('PlaceOrderBlock').focus();

  };

  onCouponCode() {
    this.service
      .get(this.baseUrl + "CouponAPI/GetCouponAmount/" + this.couponCode)
      .subscribe(
        (data) => {
          console.log(data);
          if (data != null) {
            this.couponDetails = data;
            this.couponId = this.couponDetails.couponId;
            this.couponAmount =
              this.netPayable - this.referralPoints - this.nowPoints <
                this.couponDetails.redemptionAmount
                ? this.netPayable
                : this.couponDetails.redemptionAmount;
            this.couponError = false;
            $("#js-upload-submit1").hide();
          } else {
            this.couponError = true;
          }
        },
        (error) => { }
      );
  }

  ApplyReferralPoint = function (ischecked) {
    if (ischecked) {
      this.referralPoints = this.availableReferralPoints;
    } else {
      this.referralPoints = 0;
    }
    console.log(this.referralPoints);
  };

  ApplyNowPoint(value) {
    if (value > this.availableNowPoints) {
      this.nowPoints = this.availableNowPoints;
    } else {
      this.nowPoints = Number(value);
    }
    this.nowPoints =
      this.netPayable - this.referralPoints - this.couponAmount < this.nowPoints
        ? this.netPayable - this.referralPoints - this.couponAmount
        : this.nowPoints;
    console.log(this.nowPoints);
  }

  Order = function (Grandtotal) {
    this.loaderService.display(true);
    this.disableOrder = true;
    if (this.ppavl == true) {
      this.paymentModeId = 6;
      this.paymentStatusId = 4;
      var phonepeTid = "yes";
    } else {
      phonepeTid = "no";
    }
    for (let i = 0; i < this.cartItems.length; i++) {
      if (this.cartItems[i].CategoryId == "331") {
        var StoreId = "18"
        break;
      }
    }
    let checkoutDetail = {
      EorderMaster: {
        PhonepeTransactionId: phonepeTid,
        EOrderCustomerId: Number(this.customerId),
        EOrderStatusId: 1,
        ETimeSlotId: this.slotId,
        EOrderTypeId: 1,
        EOrderNo: null,
        EOrderAmt: this.EcartGrandTotal,
        EShippingAmt: this.shippingCharge,
        EDiscountAmt: this.EcartTotalDiscount,
        EGrandTotal:
          this.netPayable -
          this.couponAmount -
          this.referralPoints -
          this.nowPoints,
        EOrderDate: this.todaysDate,
        EOrderDueDate: this.orderDueDate,
        EPaymentModeId: this.paymentModeId,
        EPaymentStatusId: this.paymentStatusId,
        ETotalSaving: 0,
        EAddressId: this.AddressId,
        StoreId: StoreId == "18" ? "18" : "14",
        ReferralPoint: this.referralPoints,
        NowPoint: this.nowPoints,
        CouponId: this.couponId,
      },
      EOrder: this.orderedProduct,
      ReferralPoint: 0,
      ReferralMoney: this.referralDiscount,
      CustomerMobile: this.CustomerDetails.mobileNumber,
      CustomerMail: this.CustomerDetails.email,
    };
    console.log(checkoutDetail);

    // pageDown service
    this.service.get(this.baseUrl + "ErrorStatusAPI/GetAllStatus/").subscribe(
      (data) => {
        console.log(data);
        var statusForPageDown = data;
        console.log(statusForPageDown.length);
        for (let i = 0; i < statusForPageDown.length; i++) {
          if (statusForPageDown[i].id == 2) {
            this.pageDown = statusForPageDown[i].status;
          }
        }
        if (this.pageDown == true) {
          this.loaderService.display(true);
          this.service
            .create(this.baseUrl + "EOrderAPI/EorderAdd", checkoutDetail)
            .subscribe(
              (data) => {
                console.log(data);
                this.orderId = data;

                if (this.orderId == "false") {
                  this.showSlotErrorMsg = true;
                  this.getDeliverySlots();
                } else {
                  this.loaderService.display(false);
                  if (this.ppavl != true) {
                    console.log("delete cart ")
                    localStorage.removeItem("cart");
                    this.addToCartService.deleteCart();
                  }
                  this.updatePoints();

                  if (this.paymentModeId != 3) {
                    if (this.paymentModeId == 6) {
                      this.phonepePayment();
                    } else {
                      this.router.navigate(["successful-order"], {
                        queryParams: { status: "true", orderId: this.orderId },
                      });
                    }
                  } else {
                    window.location.href =
                      this.paymentURL + "?orderid=" + this.orderId;
                  }
                  this.loaderService.display(false);
                }
              },
              (error) => {
                this.disableOrder = false;
                this.loaderService.display(false);
              }
            );
        } else {
          this.loaderService.display(false);
          this.router.navigate([""]);
        }
      },
      (error) => { }
    );
  };

  updatePoints() {
    let sendData = {
      CustomerId: Number(this.customerId),
      NowPoints: -this.nowPoints,
      RefferalPoints: -this.referralPoints,
    };
    this.service
      .create(
        this.baseUrl + "ReturnAPI/EditNowPoints/" + Number(this.customerId),
        sendData
      )
      .subscribe(
        (data) => { },
        (error) => {
          this.loaderService.display(false);
        }
      );
  }

  openTab = function (target) {
    $("#tablist")
      .find("ul li[aria-controls='" + target + "'] a")
      .trigger("click");
  };
  openAddAddress = function () {
    $("#tablist").find("ul li[aria-controls='add-address'] a").trigger("click");
  };

  openWarningModel() {
    this.modalService
      .open(this.modalContent, { backdrop: "static", keyboard: false })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }
  async phonepePayment() {
    //  this.http.get("https://apistagingnowgrocery.ajatus.in/api/EOrderAPI/GetSingleOrder/10432")this.orderId
    this.loaderService.display(true);
    this.http
      .get(this.baseUrl + "EOrderAPI/GetEorderListByMasterId/" + this.orderId)
      .subscribe(
        (data) => {
          console.log(data);
          //  this.dataPush(data);
          this.loaderService.display(false);

          this.orderDetails = data;
          this.getMerchantId();
          // console.log(this.orderDetails)
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getMerchantId() {
    this.loaderService.display(true);

    this.http.get(this.baseUrl + "PhonepeCredentialsAPI/GetAllTrue/").subscribe(
      (data) => {
        console.log(data);
        this.merchantId = data;
        console.log(this.merchantId.merchantID);
        this.dataPush(this.merchantId.merchantID);
        this.loaderService.display(false);
      },
      (error) => {
        console.log(error);
        this.loaderService.display(false);
      }
    );
  }

  dataPush(merchantId) {
    //  this.orderDetails = data;
    console.log(this.orderDetails);
    let eorderLength = this.orderDetails.eorderList.length;
    console.log(eorderLength);
    var cartItemsToPush;

    for (var i = 0; i < eorderLength; i++) {
      cartItemsToPush = {
        category: "SHOPPING",
        itemId: this.orderDetails.eorderList[i].productId,
        price: this.orderDetails.eorderList[i].price * 100,
        itemName: this.orderDetails.eorderList[i].productName,
        quantity: this.orderDetails.eorderList[i].quantity,
        address: {
          addressString: this.orderDetails.customerAddress,
          city: this.orderDetails.city,
          pincode: this.orderDetails.pincode,
          country: "INDIA",
          latitude: 1,
          longitude: 1,
        },
        shippingInfo: {
          deliveryType: "STANDARD",
          time: {
            timestamp: Date.now(),
            zoneOffSet: "+05:30",
          },
        },
      };
      this.cartProducts.push(cartItemsToPush);
    }
    console.log(this.cartProducts);
    var phonepeBody = {
      orderContext: {
        trackingInfo: {
          type: "HTTPS",
          url:
            environment.phonepeReturnUrl +
            this.orderDetails.eorderMasterId +
            "/?utm_source=phonepe",
        },
      },
      fareDetails: {
        totalAmount: this.orderDetails.eorderAmt * 100,
        payableAmount: this.orderDetails.egrandTotal * 100,
      },
      cartDetails: {
        cartItems: this.cartProducts,
      },
    };
    console.log(phonepeBody);
    var myJSON = JSON.stringify(phonepeBody);
    var encodedData = window.btoa(myJSON);
    console.log(encodedData);
    let phonepeEncodedObject = {
      merchantId: merchantId,
      amount: this.orderDetails.egrandTotal * 100,
      validFor: 300000,
      // subMerchantId: "",// needs to send only when mentioned by PhonePe integration team//
      transactionId: this.orderDetails.phonepeTransactionId,
      merchantOrderId: this.orderDetails.eorderMasterId,
      redirectUrl:
        environment.phonepeReturnUrl +
        this.orderDetails.eorderMasterId +
        "/?utm_source=phonepe",
      transactionContext: encodedData,
    };
    let encodedObjectString = JSON.stringify(phonepeEncodedObject);
    let base64EncodedStringBody = window.btoa(encodedObjectString); //For Request body and calculating X-Verify

    // let shaObj = new jsSHA("SHA-256", "TEXT");
    // // base64EncodedStringBody = "ewoJIm1lcmNoYW50SWQgIjogIlJBWk9SUEFZTUFJTiAiLAoJImFtb3VudCI6IDEwMDAwMDAwLAoJInZhbGlkRm9yIjogOTAwMDAwLAoJInN1Yk1lcmNoYW50SWQiOiAiOTE3YzNlNWU1MDMzOTE5ZTNjNWRkN2I5YWRiYWFmYjVmMjBmOWMxYiIsCgkidHJhbnNhY3Rpb25JZCI6ICJZR1lHWTg4ODg4VUlIR0dUWWlpaWlpVFlVWVUiLAoJIm1lcmNoYW50T3JkZXJJZCI6ICJZR1lHWTg4ODg4VUlIR0dUWWlpaWlpVFlVWVUiLAoJInRyYW5zYWN0aW9uQ29udGV4dCI6ICJld29KSW05eVpHVnlRMjl1ZEdWNGRDSTZJSHNLQ1FraWRISmhZMnRwYm1kSmJtWnZJam9nZXdvSkNRa2lkSGx3WlNJNklDSklWRlJRVXlJc0Nna0pDU0oxY213aU9pQWlhSFIwY0hNNkx5OW5iMjluYkdVdVkyOXRJZ29KQ1gwS0NYMHNDZ2tpWm1GeVpVUmxkR0ZwYkhNaU9pQjdDZ2tKSW5SdmRHRnNRVzF2ZFc1MElqb2dNemt3TUN3S0NRa2ljR0Y1WVdKc1pVRnRiM1Z1ZENJNklETTVNREFLQ1gwc0Nna2lZMkZ5ZEVSbGRHRnBiSE1pT2lCN0Nna0pJbU5oY25SSmRHVnRjeUk2SUZ0N0Nna0pDU0pqWVhSbFoyOXllU0k2SUNKR1QwOUVJaXdLQ1FrSkltbDBaVzFKWkNJNklDSXhNak0wTlRZM09Ea3dJaXdLQ1FrSkluQnlhV05sSWpvZ016a3dNQ3dLQ1FrSkltbDBaVzFPWVcxbElqb2dJbFJGVTFRaUxBb0pDUWtpWkdWc2FYWmxjbmxKYm1adklqb2dld29KQ1FrSkltUmxiR2wyWlhKNVZIbHdaU0k2SUNKVFZFRk9SRUZTUkNJc0Nna0pDUWtpZEdsdFpTSTZJSHNLQ1FrSkNRa2lkR2x0WlhOMFlXMXdJam9nTVRVMk1UVTBNREl4T0N3S0Nna0pDUWtKSW5wdmJtVlBabVpUWlhRaU9pQWlLekExT2pNd0lnb0pDUWtKZlFvSkNRbDlMQW9KQ1FraWIzSmtaWEpVZVhCbElqb2dJazlPWDBSRlRVRk9SQ0lzQ2drSkNTSmhaR1J5WlhOeklqb2dld29KQ1FrSkltRmtaSEpsYzNOVGRISnBibWNpT2lBaVZFVlRWQ0lzQ2drSkNRa2lZMmwwZVNJNklDSlVSVk5VSWl3S0NRa0pDU0p3YVc1amIyUmxJam9nSWxSRlUxUWlMQW9KQ1FrSkltTnZkVzUwY25raU9pQWlWRVZUVkNJc0Nna0pDUWtpYkdGMGFYUjFaR1VpT2lBeExBb0pDUWtKSW14dmJtZHBkSFZrWlNJNklERUtDUWtKZlN3S0NRa0pJbkYxWVc1MGFYUjVJam9nTVFvSkNYMWRDZ2w5Q2dwOSIsCgkicmVkaXJlY3RVcmwiOiAiaHR0cHM6IC8vdGVzdC1tZXJjaGFudC5jb20vb3JkZXIvNDIzMTQyMzMyMzIiCn0="
    // shaObj.update(
    //   base64EncodedStringBody +
    //   "/v3/transaction/sdk-less/initiate" +
    //   "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
    // );
    // let hash1 = shaObj.getHash("HEX");
    // var hash = hash1.toUpperCase();
    // console.log(hash1);
    // console.log(hash);
    // var xVerifyHeader = hash + "###" + 1; //x verify
    // // let xCallbackUrl = "https://apistagingnowgrocery.ajatus.in/api/EOrderAPI/GetSingleOrder/10613"
    // console.log(base64EncodedStringBody);
    // console.log(xVerifyHeader);
    this.postOrderDataPhonepe(base64EncodedStringBody);
  }
  postOrderDataPhonepe(requestBody) {
    this.loaderService.display(true);
    localStorage.setItem("isFromChekoutPhonePe", "true")
    console.log(localStorage.getItem("isFromChekoutPhonePe"))
    console.log("phone pe payment called");
    let requestObject = {
      request: requestBody,
      XVERIFY: this.baseUrl,
    };

    this.http
      .post(
        this.baseUrl + "LoginAPI/PhonepePaymentRedirectionURL",
        requestObject
      )
      .subscribe(
        (data) => {
          this.responsePayment = data;
          this.loaderService.display(false);

          console.log(this.responsePayment);
          console.log(this.responsePayment.data.redirectUrl);
          if (this.responsePayment.code == "SUCCESS") {
            window.location.href = this.responsePayment.data.redirectUrl;
          } else {
            alert("Payment Failed");
            console.log("redirect url not found");
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    //  getTransactionId(){

    // this.http.get(this.baseUrl + 'LoginAPI/PhonepePaymentRedirectionUR)
    //   .subscribe(
    //   data => {
    //       console.log(data)
    //   this.responseForPayment=data
    //      this.responseForPayment.redirectUrl;
    //      // window.location.href=response.redirectUrl
    //     },
    //     (error) => {
    //       console.log(error)
    //     })

    //  }
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/checkout/checkout.component.ts